import React from 'react';
import styles from './text-barchart.module.scss';
import Legend from './legend';
const TextBarChart = ({ data }) => {
  const { value } = data;
  const isMediumOrHigh = value === 'Moderate' || value === 'High';

  return (
    <div>
      <div className={styles.textBarChart}>
        <div className={styles.barWrapper}>
          <span className={styles.barText}>{value === 'Lower' && value}</span>

          <div
            className={styles.bar}
            style={{
              background: 'black',
            }}
          />
        </div>
        <div className={styles.barWrapper}>
          <span className={styles.barText}>
            {value === 'Moderate' && value}
          </span>

          <div
            className={styles.bar}
            style={{
              background: isMediumOrHigh ? 'black' : '#ECEBEE',
            }}
          />
        </div>
        <div className={styles.barWrapper}>
          <span className={styles.barText}>{value === 'High' && value}</span>

          <div
            className={styles.bar}
            style={{
              background: value === 'High' ? 'black' : '#ECEBEE',
            }}
          />
        </div>
      </div>
      <Legend {...data} />
    </div>
  );
};

export default TextBarChart;



// WEBPACK FOOTER //
// ./src/components/bar-chart/text-barchart.js